<div class="grid" [style.grid-template-rows]="gridTemplateRows" [style.grid-template-columns]="gridTemplateColumns">
  @for (child of children; track child) {
    <ng-template #children></ng-template>
  }
</div>
